import React from "react";
import { FormattedMessage } from "react-intl";

interface ITosSingaporeProps {
  company: any;
}

function TosSingapore({ company }: ITosSingaporeProps) {
  return (
    <div className="tos-page-mobile">
      <div className="container">
        <h1 className="text-center">
          <p className="title-text">{company.name}</p>
          <p className="title-text">
            <FormattedMessage id="tos.sg.terms_of_service" />
          </p>
        </h1>

        {/* Introduction */}
        <p>
          <FormattedMessage id="tos.sg.introduction" />
        </p>
        <p>
          <FormattedMessage id="tos.sg.read_carefully" />
        </p>
        <p>
          <FormattedMessage id="tos.sg.violation_remedies" />
        </p>
        <p>
          <FormattedMessage id="tos.sg.terms_changes" />
        </p>

        {/* Section 1: Use of Platforms */}
        <h5>
          <FormattedMessage id="tos.sg.use_of_platforms" />
        </h5>
        <ol>
          <li>
            <FormattedMessage id="tos.sg.use_1_1" />
          </li>
          <li>
            <FormattedMessage id="tos.sg.use_1_2" />
          </li>
          <li>
            <FormattedMessage id="tos.sg.use_1_3" />
          </li>
          <li>
            <FormattedMessage id="tos.sg.use_1_4" />
          </li>
        </ol>

        {/* Section 2: General Terms of Service */}
        <h5>
          <FormattedMessage id="tos.sg.general_terms" />
        </h5>
        <ol>
          <p>
            <strong>
              <FormattedMessage id="tos.sg.orders" />
            </strong>
          </p>
          <ol>
            <li>
              <FormattedMessage id="tos.sg.orders_2_1_1" />
            </li>
            <li>
              <FormattedMessage id="tos.sg.orders_2_1_2" />
            </li>
            <li>
              <FormattedMessage id="tos.sg.orders_2_1_3" />
            </li>
            <li>
              <FormattedMessage id="tos.sg.orders_2_1_4" />
            </li>
            <li>
              <FormattedMessage id="tos.sg.orders_2_1_5" />
            </li>
            <li>
              <FormattedMessage id="tos.sg.orders_2_1_6" />
            </li>
            <li>
              <FormattedMessage id="tos.sg.orders_2_1_7" />
            </li>
          </ol>

          <p>
            <strong>
              <FormattedMessage id="tos.sg.cancelling_orders" />
            </strong>
          </p>
          <ol>
            <li>
              <FormattedMessage id="tos.sg.cancelling_2_2_1" />
            </li>
            <li>
              <FormattedMessage id="tos.sg.cancelling_2_2_2" />
            </li>
            <li>
              <FormattedMessage id="tos.sg.cancelling_2_2_3" />
            </li>
          </ol>
          <p>
            <FormattedMessage id="tos.sg.general_2_3" />
          </p>
          <p>
            <FormattedMessage id="tos.sg.general_2_4" />
          </p>
        </ol>

        {/* Section 3: Restrictions */}
        <h5>
          <FormattedMessage id="tos.sg.restrictions" />
        </h5>
        <ol>
          <p>
            <FormattedMessage id="tos.sg.restrictions_3_1" />
          </p>
          <p>
            <FormattedMessage id="tos.sg.restrictions_3_2" />
          </p>
        </ol>

        {/* Section 4: Restricted Products */}
        <h5>
          <FormattedMessage id="tos.sg.restricted_products" />
        </h5>
        <ol>
          <p>
            <FormattedMessage id="tos.sg.restricted_4_1" />
          </p>
          <p>
            <FormattedMessage id="tos.sg.restricted_4_2" />
          </p>
        </ol>

        {/* Section 5: Pickup and Delivery */}
        <h5>
          <FormattedMessage id="tos.sg.pickup_delivery" />
        </h5>
        <ol>
          <li>
            <FormattedMessage id="tos.sg.pickup_delivery_5_1" />
          </li>
          <li>
            <FormattedMessage id="tos.sg.pickup_delivery_5_2" />
          </li>
        </ol>

        {/* Section 6: Payments */}
        <h5>
          <FormattedMessage id="tos.sg.payments" />
        </h5>
        <ol>
          <p>
            <FormattedMessage id="tos.sg.payments_6_1" />
          </p>
          <p>
            <FormattedMessage id="tos.sg.payments_6_2" />
          </p>
        </ol>

        {/* Section 7: Vouchers, Discounts and Promotions */}
        <h5>
          <FormattedMessage id="tos.sg.vouchers_promotions" />
        </h5>
        <ol>
          <p>
            <FormattedMessage id="tos.sg.vouchers_7_1" />
          </p>
          <p>
            <FormattedMessage id="tos.sg.vouchers_7_2" />
          </p>
        </ol>

        {/* Section 8: Intellectual Property */}
        <h5>
          <FormattedMessage id="tos.sg.intellectual_property" />
        </h5>
        <ol>
          <p>
            <FormattedMessage id="tos.sg.ip_8_1" />
          </p>
          <p>
            <FormattedMessage id="tos.sg.ip_8_2" />
          </p>
          <p>
            <FormattedMessage id="tos.sg.ip_8_3" />
          </p>
        </ol>

        {/* Section 9: Representations and Warranties */}
        <h5>
          <FormattedMessage id="tos.sg.representations_warranties" />
        </h5>
        <p>
          <FormattedMessage id="tos.sg.representations" />
        </p>

        {/* Section 10: Disclaimer */}
        <h5>
          <FormattedMessage id="tos.sg.disclaimer" />
        </h5>
        <p>
          <FormattedMessage id="tos.sg.disclaimer_text" />
        </p>
        <p>
          <FormattedMessage id="tos.sg.payment_security_disclaimer" />
        </p>
        <p>
          <FormattedMessage id="tos.sg.reliance_disclaimer" />
        </p>
        <p>
          <FormattedMessage id="tos.sg.disclaimer_scope" />
        </p>

        {/* Section 11: User Obligations */}
        <h5>
          <FormattedMessage id="tos.sg.user_obligations" />
        </h5>
        <ol>
          <p>
            <FormattedMessage id="tos.sg.user_obligations_11_1" />
          </p>
          <ol>
            <li>
              <FormattedMessage id="tos.sg.user_obligations_11_1_1" />
            </li>
            <li>
              <FormattedMessage id="tos.sg.user_obligations_11_1_2" />
            </li>
            <li>
              <FormattedMessage id="tos.sg.user_obligations_11_1_3" />
            </li>
            <li>
              <FormattedMessage id="tos.sg.user_obligations_11_1_4" />
            </li>
            <li>
              <FormattedMessage id="tos.sg.user_obligations_11_1_5" />
            </li>
          </ol>
        </ol>

        {/* Section 12: Indemnity */}
        <h5>
          <FormattedMessage id="tos.sg.indemnity" />
        </h5>
        <p>
          <FormattedMessage id="tos.sg.indemnity_text" />
        </p>

        {/* Section 13: Limitation of Liability */}
        <h5>
          <FormattedMessage id="tos.sg.limitation_liability" />
        </h5>
        <p>
          <FormattedMessage id="tos.sg.limitation_text" />
        </p>

        {/* Section 14: Privacy */}
        <h5>
          <FormattedMessage id="tos.sg.privacy" />
        </h5>
        <p>
          <FormattedMessage id="tos.sg.privacy_text" />
        </p>

        {/* Section 15: Third Party Links */}
        <h5>
          <FormattedMessage id="tos.sg.third_party_links" />
        </h5>
        <p>
          <FormattedMessage id="tos.sg.third_party_text" />
        </p>

        {/* Section 16: Termination */}
        <h5>
          <FormattedMessage id="tos.sg.termination" />
        </h5>
        <p>
          <FormattedMessage id="tos.sg.termination_text" />
        </p>

        {/* Section 17: Force Majeure */}
        <h5>
          <FormattedMessage id="tos.sg.force_majeure" />
        </h5>
        <p>
          <FormattedMessage id="tos.sg.force_majeure_text" />
        </p>

        {/* Section 18: Governing Law and Dispute Resolution */}
        <h5>
          <FormattedMessage id="tos.sg.governing_law" />
        </h5>
        <p>
          <FormattedMessage id="tos.sg.governing_law_text" />
        </p>

        {/* Section 19: Entire Agreement */}
        <h5>
          <FormattedMessage id="tos.sg.entire_agreement" />
        </h5>
        <p>
          <FormattedMessage id="tos.sg.entire_agreement_text" />
        </p>

        {/* Section 20: Waiver */}
        <h5>
          <FormattedMessage id="tos.sg.waiver" />
        </h5>
        <p>
          <FormattedMessage id="tos.sg.waiver_text" />
        </p>

        {/* Section 21: Severability */}
        <h5>
          <FormattedMessage id="tos.sg.severability" />
        </h5>
        <p>
          <FormattedMessage id="tos.sg.severability_text" />
        </p>

        {/* Section 22: Contact Us */}
        <h5>
          <FormattedMessage id="tos.sg.contact_us" />
        </h5>
        <p>
          <FormattedMessage id="tos.sg.contact_us_text" />
        </p>
        <p>
          <FormattedMessage id="tos.sg.contact_us_email" values={{ email: company.configuration?.email || "-" }} />
        </p>
        <p>
          <FormattedMessage id="tos.sg.contact_us_phone" values={{ phone: company.configuration?.contact_number || "-" }} />
        </p>
      </div>
    </div>
  );
}

export default TosSingapore; 